import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const DataTable = ({ title, newButtonRoute, data, onUpdate }) => {

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(8);
  const [selectedInstituicao, setSelectedInstituicao] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editInstituicao, setEditInstituicao] = useState(null);

  const handleSearchChange = (e) => setSearch(e.target.value);
  const handleEntriesChange = (e) => setEntries(e.target.value);

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const filteredData = data.filter((item) =>
    item.nomeOSC.toLowerCase().includes(search.toLowerCase())
  );

  const handleView = (instituicao) => {
    setSelectedInstituicao(instituicao);
    setShowViewModal(true);
  };

  const handleEdit = (instituicao) => {
    setEditInstituicao({ ...instituicao });
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}instituicoes/${id}`, {
        method: "DELETE",
      });
      if (response.ok) {
        console.log("Instituição excluída com sucesso!");
        if (typeof onUpdate === "function") onUpdate();
      } else {
        console.error("Erro ao excluir instituição.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  const handleCloseView = () => setShowViewModal(false);
  const handleCloseEdit = () => setShowEditModal(false);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditInstituicao({
      ...editInstituicao,
      [name]: value,
    });
  };

  const handleEditSubmit = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}instituicoes/${editInstituicao.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editInstituicao),
      });

      if (response.ok) {
        console.log("Instituição atualizada com sucesso!");
        setShowEditModal(false);
        if (typeof onUpdate === "function") onUpdate();
      } else {
        console.error("Erro ao atualizar instituição.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title">{title}</h3>
        <div className="btn-list">
          <NavLink to={newButtonRoute} className="btn btn-primary d-flex align-items-center">
            <span className="ms-1">Novo</span>
          </NavLink>
        </div>
      </div>

      <div className="card-body border-bottom py-3">
        <div className="d-flex">
          <div className="text-secondary">
            Mostrar
            <div className="mx-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={entries}
                onChange={handleEntriesChange}
                size="3"
                aria-label="Invoices count"
              />
            </div>
            registros
          </div>
          <div className="ms-auto text-secondary">
            Procurar:
            <div className="ms-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={search}
                onChange={handleSearchChange}
                aria-label="Procurar"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table card-table table-vcenter text-nowrap datatable">
          <thead>
            <tr>
              <th className="w-1">
                <input
                  className="form-check-input m-0 align-middle"
                  type="checkbox"
                  aria-label="Selecionar todos os registros"
                />
              </th>
              <th className="w-1">SIGED Nr.</th>
              <th>OSC</th>
              <th>CNPJ/CPF</th>
              <th>Telefone</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.slice(0, entries).map((item) => (
                <tr key={item.id}>
                  <td>
                    <input
                      className="form-check-input m-0 align-middle"
                      type="checkbox"
                      aria-label="Select invoice"
                    />
                  </td>
                  <td><span className="text-secondary">{item.sigedNR}</span></td>
                  <td>{truncateText(item.nomeOSC, 20)}</td>
                  <td>{truncateText(item.cnpj, 18)}</td>
                  <td>{truncateText(item.telefone)}</td>
                  <td></td>
                  <td className="text-end">
                    <span className="dropdown">
                      <button className="btn dropdown-toggle align-text-top" data-bs-toggle="dropdown">Ações</button>
                      <div className="dropdown-menu dropdown-menu-end">
                        <button className="dropdown-item" onClick={() => handleView(item)}>Ver</button>
                        <button className="dropdown-item" onClick={() => handleEdit(item)}>Editar</button>
                        <button
                          className="dropdown-item text-red"
                          onClick={() => handleDelete(item.id)}
                        >
                          Excluir
                        </button>
                      </div>
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  Não existem instituições cadastradas
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="card-footer d-flex align-items-center">
        <p className="m-0 text-secondary">
          Exibindo <span>1</span> até <span>{Math.min(entries, filteredData.length)}</span> de <span>{filteredData.length}</span> registros
        </p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item disabled">
            <a className="page-link" href="#" aria-disabled="true">ante</a>
          </li>
          <li className="page-item active">
            <a className="page-link" href="#">1</a>
          </li>
          <li className="page-item"><a className="page-link" href="#">2</a></li>
          <li className="page-item"><a className="page-link" href="#">3</a></li>
          <li className="page-item">
            <a className="page-link" href="#">prox</a>
          </li>
        </ul>
      </div>

      {/* Modal para visualização */}
      <Modal show={showViewModal} onHide={handleCloseView}>
      <Modal.Header closeButton>
        <Modal.Title>Detalhes da Instituição</Modal.Title>
      </Modal.Header>
      <Modal.Body>
          {selectedInstituicao ? (
            <div>
              <p><strong>SIGED Nr:</strong> {selectedInstituicao.sigedNR}</p>
              <p><strong>Nome OSC:</strong> {selectedInstituicao.nomeOSC}</p>
              <p><strong>CNPJ/CPF:</strong> {selectedInstituicao.cnpj}</p>
              <p><strong>Endereço:</strong> {selectedInstituicao.endereco}</p>
              <p><strong>Responsável pela Entidade:</strong> {selectedInstituicao.responsavelEntidade}</p>
              <p><strong>Telefone:</strong> {selectedInstituicao.telefone}</p>
              <p><strong>Email:</strong> {selectedInstituicao.email}</p>
              <p><strong>Título do Projeto:</strong> {selectedInstituicao.tituloProjeto}</p>
              <p><strong>Número de Beneficiários:</strong> {selectedInstituicao.numeroBeneficiarios}</p>
              <p><strong>Valor:</strong> {selectedInstituicao.valor}</p>
              <p><strong>Objetivo Geral:</strong> {selectedInstituicao.objetivoGeral}</p>
              <p><strong>Objetivos Específicos:</strong> {selectedInstituicao.objetivosEspecificos}</p>
              <p><strong>Cronograma de Execução:</strong> {selectedInstituicao.cronogramaExecucao}</p>
              <p><strong>Indicadores de Monitoramento:</strong> {selectedInstituicao.indicadoresMonitoramento}</p>

              {/* Informações do Gestor */}
              {selectedInstituicao.gestor ? (
                <>
                  <p><strong>Nome do Gestor:</strong> {selectedInstituicao.gestor.nome_gestor}</p>
                  <p><strong>Cargo do Gestor:</strong> {selectedInstituicao.gestor.cargo_gestor}</p>
                  <p><strong>Matrícula do Gestor:</strong> {selectedInstituicao.gestor.matricula_gestor}</p>
                  <p><strong>Designação:</strong> {selectedInstituicao.gestor.designacao}</p>
                  <p><strong>Portaria:</strong> {selectedInstituicao.gestor.portaria}</p>
                  <p><strong>Edição:</strong> {selectedInstituicao.gestor.edicao}</p>
                  <p><strong>Página:</strong> {selectedInstituicao.gestor.pagina}</p>
                </>
              ) : (
                <p>Gestor não vinculado.</p>
              )}

              <p><strong>Termo de Fomento:</strong> {selectedInstituicao.termoFomento}</p>
            </div>
          ) : (
            <p>Carregando...</p>
          )}
        </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseView}>Fechar</Button>
      </Modal.Footer>
    </Modal>

      {/* Modal para edição */}
      <Modal show={showEditModal} onHide={handleCloseEdit}>
      <Modal.Header closeButton>
        <Modal.Title>Editar Instituição</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {editInstituicao ? (
          <form>
            <div className="mb-3">
              <label className="form-label">SIGED Nr</label>
              <input
                type="text"
                className="form-control"
                name="sigedNR"
                value={editInstituicao.sigedNR}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Nome OSC</label>
              <input
                type="text"
                className="form-control"
                name="nomeOSC"
                value={editInstituicao.nomeOSC}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">CNPJ/CPF</label>
              <input
                type="text"
                className="form-control"
                name="cnpj"
                value={editInstituicao.cnpj}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Endereço</label>
              <input
                type="text"
                className="form-control"
                name="endereco"
                value={editInstituicao.endereco}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Responsável pela Entidade</label>
              <input
                type="text"
                className="form-control"
                name="responsavelEntidade"
                value={editInstituicao.responsavelEntidade}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Telefone</label>
              <input
                type="text"
                className="form-control"
                name="telefone"
                value={editInstituicao.telefone}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={editInstituicao.email}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Título do Projeto</label>
              <input
                type="text"
                className="form-control"
                name="tituloProjeto"
                value={editInstituicao.tituloProjeto}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Número de Beneficiários</label>
              <input
                type="text"
                className="form-control"
                name="numeroBeneficiarios"
                value={editInstituicao.numeroBeneficiarios}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Valor</label>
              <input
                type="text"
                className="form-control"
                name="valor"
                value={editInstituicao.valor}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Objetivo Geral</label>
              <textarea
                className="form-control"
                name="objetivoGeral"
                value={editInstituicao.objetivoGeral}
                onChange={handleEditChange}
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">Objetivos Específicos</label>
              <textarea
                className="form-control"
                name="objetivosEspecificos"
                value={editInstituicao.objetivosEspecificos}
                onChange={handleEditChange}
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">Cronograma de Execução</label>
              <textarea
                className="form-control"
                name="cronogramaExecucao"
                value={editInstituicao.cronogramaExecucao}
                onChange={handleEditChange}
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">Indicadores de Monitoramento</label>
              <textarea
                className="form-control"
                name="indicadoresMonitoramento"
                value={editInstituicao.indicadoresMonitoramento}
                onChange={handleEditChange}
              ></textarea>
            </div>
            <div className="mb-3">
              <label className="form-label">Nome do Gestor</label>
              <input
                type="text"
                className="form-control"
                name="nomeGestor"
                value={editInstituicao.nomeGestor}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Cargo do Gestor</label>
              <input
                type="text"
                className="form-control"
                name="cargoGestor"
                value={editInstituicao.cargoGestor}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Matrícula do Gestor</label>
              <input
                type="text"
                className="form-control"
                name="matriculaGestor"
                value={editInstituicao.matriculaGestor}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Designação</label>
              <input
                type="text"
                className="form-control"
                name="designacao"
                value={editInstituicao.designacao}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Portaria</label>
              <input
                type="text"
                className="form-control"
                name="portaria"
                value={editInstituicao.portaria}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Edição</label>
              <input
                type="text"
                className="form-control"
                name="edicao"
                value={editInstituicao.edicao}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Página</label>
              <input
                type="text"
                className="form-control"
                name="pagina"
                value={editInstituicao.pagina}
                onChange={handleEditChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Termo de Fomento</label>
              <input
                type="text"
                className="form-control"
                name="termoFomento"
                value={editInstituicao.termoFomento}
                onChange={handleEditChange}
              />
            </div>
          </form>
        ) : (
          <p>Carregando...</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseEdit}>Cancelar</Button>
        <Button variant="primary" onClick={handleEditSubmit}>Salvar</Button>
      </Modal.Footer>
    </Modal>
    </div>
  );
};

export default DataTable;